module.exports = __webpack_public_path__ + "img/9f4cc011fe51a9b7c8220f3be722ada4.png";